module.exports = __webpack_public_path__ + "img/secretheart.a3c33e6.webp";